<template>
    <div class="picker explainFill"
        :class="mustFlag">
        <h6><span></span>说明或描述</h6>
        <div class="textBox">
            <textarea 
                name="" id=""  
                placeholder="请输入说明文字..." 
                @input="descInput" 
                v-model.trim="desc"
                @change="getMess"></textarea>
        </div>
        <p class="mess_num"><em class="num">{{remnant}}</em>/100字</p>
    </div>
</template>

<script>

    export default {
        props: ["mustFlag"],
        data(){
            return{
                remnant : 0,
                desc:''
            }
        },
        created () {

        },
        methods:{
            descInput(){
                let textVal = this.desc.replace(/\s/g,"").length;
                this.desc = this.desc.replace(/\s/g,"")
                if(textVal >= 100){
                    this.desc = this.desc.substring(0, 100)
                    textVal = 100
                }
                this.remnant = textVal
            },
            getMess(){
                this.$emit('transMess' , ['desc' , this.desc])
            }
        }
    }
</script>

<style lang="less">
    .explainFill{
        padding-bottom: 5px;
        margin-left: 15px;
        width: 100%;
        height: auto;
        border-bottom: 1px solid #EAEAEA;
        .tit{
            padding-top: 13px;
            font-family: "PingFangSC-Regular";
            font-size: 15px;
            color: #666666;
            letter-spacing: 0;
            line-height: 24px;
        }
        .textBox{
            margin: -5px 15px 0 0;
            width: auto;
            textarea{
                width: 100%;
                height: 110px;
                text-indent: 0;
                resize: none;
                font-family: "HiraginoSansGB-W3";
                font-size: 16px;
                letter-spacing: 0;
                text-align: left;
                line-height: 22px;
            }
        }
        .mess_num{
            margin: -12px 15px 0 0;
            width: auto;
            font-family: PingFangSC-Regular;
            font-size: 10px;
            color: #AAAAAA;
            letter-spacing: -0.48px;
            line-height: 11px;
            text-align: right;
        }
        textarea::-webkit-input-placeholder {
            color: #aaa;
        }

        textarea::-moz-placeholder {
            color: #aaa;
        }

        textarea::-moz-placeholder {
            color: #aaa;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ExplainFill/ExplainFill.vue